import { Component, OnInit, ViewChild, NgModule } from "@angular/core";
import { formatMessage } from "devextreme/localization";
import { DxLookupModule, DxSelectBoxModule } from "devextreme-angular";
import { CommonModule } from "@angular/common";
import {
  ComponentPricelistModule,
  ComponentPricelistComponent,
} from "../../shared/components/component-pricelist/component-pricelist.component";
import { ReturnButtonModule } from "../../shared/components/return-button/return-button.component";
import { KachelModule } from "../../shared/components/kachel/kachel.component";
import { OrganizationService } from "../../shared/services/organization.service";
import { Publisher } from "../../shared/model/organization/organization";
import { finalize } from "rxjs/operators";

@Component({
  selector: "app-publisher-configuration",
  templateUrl: "./publisher-configuration.component.html",
  styleUrls: ["./publisher-configuration.component.scss"],
})
export class PublisherConfigurationComponent implements OnInit {
  @ViewChild(ComponentPricelistComponent)
  componentPricelistComponent: ComponentPricelistComponent;

  formatMessage = formatMessage;
  selectedPublisher: string | null = null;
  publishers: Publisher[] = [];
  loading = true;
  loadError = false;

  constructor(private organizationService: OrganizationService) {}

  ngOnInit(): void {
    this.loadPublishers();
  }

  private loadPublishers(): void {
    this.loading = true;
    this.loadError = false;

    this.organizationService
      .findAllPublisher()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (publishers: Publisher[]) => {
          // Sort publishers alphabetically by displayName (case-insensitive)
          this.publishers = (publishers || []).sort((a, b) => {
            const displayNameA = (a.displayName || '').toLowerCase();
            const displayNameB = (b.displayName || '').toLowerCase();
            return displayNameA.localeCompare(displayNameB);
          });

          console.log("Publishers loaded:", this.publishers.length);
        },
        error: (error) => {
          console.error("Error loading publishers:", error);
          this.loadError = true;
          this.publishers = [];
        },
      });
  }

  onPublisherSelectionChanged(event: any): void {
    this.selectedPublisher = event.value;
    console.log("Selected publisher ID:", this.selectedPublisher);
  }

  retryLoadPublishers(): void {
    this.loadPublishers();
  }
  reloadComponentPriceData(event: any): void {
    console.log("Component price data upload completed:", event);

    // Trigger reload of the component price data in the child component
    if (this.componentPricelistComponent) {
      this.componentPricelistComponent.reloadData();
    }
  }
}

@NgModule({
  imports: [
    CommonModule,
    DxSelectBoxModule,
    ComponentPricelistModule,
    ReturnButtonModule,
    KachelModule,
    DxLookupModule,
  ],
  declarations: [PublisherConfigurationComponent],
  exports: [PublisherConfigurationComponent],
})
export class PublisherConfigurationModule {}
